<ng-template
  let-extraClass="extraClass"
  #topNav />

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <tidy-row [align]="'center'">
      <tidy-text
        [body]="('Add credit for ' | translate) + employee?.source_user_first_name + ' ' + employee?.source_user_last_name + ':'" />
    </tidy-row>

    <tidy-card>
      <form [formGroup]="form" novalidate action="#">
        <tidy-row class="field-top-padding field-bottom-padding">
          <tidy-input
            [label]="'Amount to add'"
            formControlName="amount"
            [form]="form.controls.amount"
            [icon]="'assets/svg/card.svg'"
            [submitted]="submitted"
            inputMode="numeric"
            [mask]="'currencyMask'"
            [errorMessage]="'Please enter an amount'" />
        </tidy-row>
      </form>
    </tidy-card>

    <tidy-row>
      <tidy-button
        [text]="'Add Credit'"
        [action]="boundAddCredit"
        class="primary" />
    </tidy-row>

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    <tidy-row [align]="'center'">
      <tidy-text
        [body]="('You currently have ' | translate) + (companyCredit | tcurrency) + (' credit you can add for employees.' | translate)" />
    </tidy-row>

  </tidy-wrapper>
</ng-template>

<ion-content class="ion-content-right-column">
  <ng-container *ngTemplateOutlet="content" />
</ion-content>
